class HmChatWidget extends HTMLElement {
  connectedCallback() {
    this.launcher = this.querySelector('[data-chat-toggle]');
    this.panel = this.querySelector('.hm-chat-widget__panel');
    this.body = this.querySelector('[data-chat-body]');

    this.launcher.addEventListener('click', () => this.toggle(!this.isOpen));
    this.querySelector('[data-chat-close]').addEventListener('click', () => {
      this.toggle(false);
      this.launcher.focus();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) this.toggle(false);
    });
  }

  // aria-expanded is the source of truth: panel.hidden stays false while the close animation runs
  get isOpen() {
    return this.launcher.getAttribute('aria-expanded') === 'true';
  }

  toggle(open) {
    if (open) {
      this.panel.classList.remove('is-closing');
      this.panel.hidden = false;
    } else {
      this.hidePanel();
    }

    this.launcher.setAttribute('aria-expanded', String(open));
    this.launcher.setAttribute(
      'aria-label',
      open ? this.launcher.dataset.labelClose : this.launcher.dataset.labelOpen
    );

    if (open) this.loadFrame();
  }

  hidePanel() {
    if (this.panel.hidden) return;

    // No animation (reduced motion) means animationend never fires, so hide right away
    if (getComputedStyle(this.panel).animationName === 'none') {
      this.panel.hidden = true;
      return;
    }

    this.panel.classList.add('is-closing');
    this.panel.addEventListener(
      'animationend',
      () => {
        // Skip if the panel was reopened while the close animation was running
        if (!this.panel.classList.contains('is-closing')) return;

        this.panel.classList.remove('is-closing');
        this.panel.hidden = true;
      },
      { once: true }
    );
  }

  // Load lazily so the chatbot page costs nothing until the customer opens it
  loadFrame() {
    if (this.body.querySelector('iframe')) return;

    let url;
    try {
      url = new URL(this.dataset.src, window.location.href);
    } catch {
      return;
    }

    // platform=mobile makes the chatbot render only its chat frame (no standalone page layout)
    url.searchParams.set('platform', 'mobile');

    const frame = document.createElement('iframe');
    frame.src = url.toString();
    frame.title = this.panel.getAttribute('aria-label');
    this.body.classList.add('is-loading');
    frame.addEventListener(
      'load',
      () => this.body.classList.remove('is-loading'),
      { once: true }
    );
    this.body.append(frame);
  }
}

if (!customElements.get('hm-chat-widget')) {
  customElements.define('hm-chat-widget', HmChatWidget);
}
